var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"ModalCreateModule","size":"lg","title":"Créer un module","header-bg-variant":"kalkin-1","header-text-variant":"light","hide-footer":""}},[_c('FormModule',{staticClass:"mb-4",on:{"saved":_vm.onSaved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }